import React, { useState, useEffect, useRef } from "react";
import { ChromePicker } from "react-color";
import { InputNumber, Popover, Button } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { ReactEditor, useSelected } from "slate-react";
import { Transforms } from "slate";

const FloatingBlockSettings = ({ element, editor, disabled }) => {
  const selected = useSelected();
  const iconRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [color, setColor] = useState(element.backgroundColor || "#fafafa");
  const [padding, setPadding] = useState(parseInt(element.padding || "8", 10));
  const [width, setWidth] = useState(element.width || 200);
  const [height, setHeight] = useState(element.height || 120);

  useEffect(() => {
    setColor(element.backgroundColor || "#fafafa");
    setPadding(parseInt(element.padding || "8", 10));
    setWidth(element.width || 200);
    setHeight(element.height || 120);
  }, [element]);

  const updateNode = (newProps) => {
    const path = ReactEditor.findPath(editor, element);
    Transforms.setNodes(editor, newProps, { at: path });
  };

  const content = (
    <div style={{ minWidth: "200px" }}>
      <label>Background:</label>
      <ChromePicker
        color={color}
        onChangeComplete={(c) => {
          setColor(c.hex);
          updateNode({ backgroundColor: c.hex });
        }}
      />
      <div style={{ marginTop: 10 }}>
        <label>Padding:</label>
        <InputNumber
          min={0}
          max={100}
          value={padding}
          onChange={(val) => {
            setPadding(val);
            updateNode({ padding: `${val}px` });
          }}
          style={{ width: "100%" }}
        />
      </div>

      {"width" in element && (
        <div style={{ marginTop: 10 }}>
          <label>Width:</label>
          <InputNumber
            min={100}
            max={1000}
            value={width}
            onChange={(val) => {
              setWidth(val);
              updateNode({ width: val });
            }}
            style={{ width: "100%" }}
          />
        </div>
      )}

      {"height" in element && (
        <div style={{ marginTop: 10 }}>
          <label>Height:</label>
          <InputNumber
            min={60}
            max={1000}
            value={height}
            onChange={(val) => {
              setHeight(val);
              updateNode({ height: val });
            }}
            style={{ width: "100%" }}
          />
        </div>
      )}
    </div>
  );

  if (!selected) return null;

  return (
    <div
      ref={iconRef}
      contentEditable={false}
      style={{ position: "absolute", top: "-24px", right: "0px", zIndex: 10 }}
    >
      <Popover
        content={content}
        title="Block Settings"
        trigger="click"
        open={visible}
       
        onOpenChange={(v) => setVisible(v)}
      >
        <Button
          icon={<SettingOutlined />}
          size="small"
          shape="circle"
          disabled={disabled}
        />
      </Popover>
    </div>
  );
};

export default FloatingBlockSettings;